import * as React from 'react';
import { Select, Spin } from 'antd';
import { adopt } from 'react-adopt';
import { isString } from 'util';

import SearchCustomers from '../../../components/Query/Customers/Customers';
import Option from './components/Option';

const SearchParams = adopt({
  search: ({ searchQuery, domain, render }) => <SearchCustomers filter={{query: searchQuery}} domain={domain}>{render}</SearchCustomers>,
  selected: ({ customerIds, domain, render }) => <SearchCustomers customerIds={customerIds} domain={domain}>{render}</SearchCustomers>,
});

export interface ICustomerSelectProps {
  name: string;
  value?: string[];
  multiple?: boolean;
  required?: boolean;
  onChange: (e: any) => void;
  domain: string;
  email?: string;
  selectCustomer?: (c: GQL.ICustomer) => void,
  selectedCustomer?: GQL.ICustomer | null,
}

export interface IAccessory {
  productId: string;
  variantId: string;
  imageUrl: string;
  title: string;
  code: string | null;
  ean: string;
  value: GQL.IAttributeValue;
}

interface ICustomerSelectState {
  searchQuery: string;
  values: string[];
}

class CustomerSelect extends React.Component<ICustomerSelectProps, ICustomerSelectState> {
  state = {
    searchQuery: '',
    values: [],
  }

  public static defaultProps = {
    multiple: false,
    required: false,
  };

  constructor(props: ICustomerSelectProps) {
    super(props);
    /**
     * When there is coming e-mail from props, then use it
     */
    if (props.email) {
      this.setState({ searchQuery: props.email });
    }
  }

  public render() {
    const { value, multiple, email, selectCustomer, selectedCustomer } = this.props;
    const { searchQuery } = this.state;
    let valueIds: string[] = [];
    if (value && Array.isArray(value)) {
      value.map(v => valueIds.push(v));
    } else if (value && isString(value)) {
      valueIds.push(value);
    }

    return (
      <div>
        <SearchParams
          customertIds={valueIds}
          searchQuery={searchQuery || email}
          domain={this.props.domain}
        >
          {(res: any) => {
            const searchCustomers = res && res.search && res.search.customers || undefined;
            let selectedCustomers = res && res.selected && res.selected.customers || undefined;
            const customers = [
              ...(Array.isArray(searchCustomers.customers) ? searchCustomers.customers : []),
              ...(Array.isArray(selectedCustomers.customers) ? selectedCustomers.customers : [])]
              .reduce((acc, customer) => {
                if (!acc.some(ac => ac.id === customer.id)) {
                  acc.push(customer);
                }
                return acc;
              }, []);
            if (!searchCustomers) {
              return 'Loading ...';
            }

            let vByEmail = '';
            if (!value && email && Array.isArray(customers)) {
              const selectedCustomerByEmail = customers.find((c: GQL.ICustomer) => {
                return c.email ===  email;
              });

              if (selectedCustomerByEmail) {
                vByEmail = selectedCustomerByEmail && selectedCustomerByEmail.id;
              }

              if (selectCustomer
                  && (selectedCustomer && selectedCustomer.id) !== (selectedCustomerByEmail&& selectedCustomerByEmail.id)) {
                selectCustomer(selectedCustomerByEmail);
              }
            }
            
            return (
              <div>
                <Select
                  allowClear={true}
                  mode={multiple === true ? 'multiple' : undefined}
                  showSearch={true}
                  labelInValue={false}
                  placeholder="Select customers"
                  notFoundContent={res.search.loading ? <Spin size="small" /> : null}
                  filterOption={false}
                  value={value || vByEmail}
                  onSearch={searchQuery => this.setState({ searchQuery })}
                  onChange={data => {
                    this.onChange(data as any);
                  }}
                  style={{ width: '100%' }}>
                    {(customers || []).map((c: GQL.ICustomer, index: any) => (
                      <Select.Option
                        title={`${c.invoiceFirstName} ${c.invoiceLastName}, ${c.email}, ${c.invoiceCity}`}
                        value={c.id}
                        key={`${c.email}${index}`}
                      >
                        <Option
                          customer={c}
                        />
                      </Select.Option>
                    ))}
                  
                </Select>
              </div>
            );
          }}
        </SearchParams>
      </div>
    );
  }

  private onChange(data: Array<string>) {
    this.setState({
      values: data,
    }, () => {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: this.state.values
        },
      });
    });
  }
}

export default CustomerSelect;


// WEBPACK FOOTER //
// ./src/components/Others/CustomerSelect/CustomerSelect.tsx